import React from "react";
import logo from "../../../images/logo.png";

function Ai({ data }) {
  return (
    <>
      {data ? (
        <div className="relative my-4 lg:my-0 ">
          <img
            src={logo}
            alt=""
            className="h-[37px] w-[18px] absolute top-0 left-0"
          />

          <div dir="ltr" className="w-fit mr-auto ml-8 max-w-[25rem]">
            <p className="text-start font-bold mb-3">مرشد محصول</p>
            <div
              className={`text-[#0D082C] bg-[#F1F7FF] py-[10px] px-[15px]  text-right rounded-r-lg rounded-b-lg ${
                data.isLoading ? "font-extrabold  text-2xl text-green-300 " : ""
              }`}
            >
              <div className={data.isLoading ? "" : ""} dir="rtl">
                {data.isLoading ? (
                  <div className="flex justify-start gap-1 items-center loading "> 
                    {/* <span className="transition delay-150 duration-300  animate-bounce ">{data.content}</span>
                    <span className="transition  duration-300  ease-in ">{data.content}</span>
                    <span className="transition duration-300  animate-bounce delay-150">{data.content}</span> */}
                    {data.content}
                  </div>
                ) : (
                  data.content
                )}
              </div>
            </div>
            <div className="text-right text-sm py-1 ">
              {new Date(data.created_at).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Ai;
